import { combineReducers } from 'redux';
import agreed from './agreed';
import completed from './completed';
import declined from './declined';

export default combineReducers({
  agreed,
  completed,
  declined,
});



// WEBPACK FOOTER //
// ./src-react/SignatureStateToolbar/SignatureStateToolbarReducer/index.jsx